<template>
<div>
    <vm-card list :header="__('shipping_agreement')" >
        <template v-slot:actions>
            <vm-tooltip-action :html="__('tip_shipping')"  />
        </template>

        <vm-row>
            <vm-group c4>
                <vm-label bold :text="__('shipping_early')" />
                <vm-input v-model="$root.translations.shipping_early_2.nb_NO" maxbo disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-label bold :text="__('order_value')" />
                <vm-dropdown bold boldOptions maxbo v-if="!skEnabled"
                    v-model="orderModel.days7"
                    :options="orderOptions.days7" />
                <vm-input v-model="orderModel.days7.value" maxbo bold v-if="skEnabled" @input="onSKChange" />
            </vm-group>
            <vm-group c2>
                <vm-label bold :text="__('discount')" />
                <vm-dropdown bold boldOptions maxbo v-if="!skEnabled"
                    v-model="discountModel.days7"
                    :options="discountOptions.days7"
                    :valid="checks.days7.discount"
                    :invalid="!checks.days7.discount"
                />
                <vm-input v-model="discountModel.days7.value" maxbo bold v-if="skEnabled" @input="onSKChange" />
            </vm-group>
            <vm-group c2>
                <vm-label bold :text="__('price_original')" />
                <vm-input v-model="prices.days7.original" maxbo bold disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-label bold :text="__('price_discount')" />
                <vm-input v-model="prices.days7.discount" maxbo bold disabled borderless :highlight="prices.days7.highlight" />
            </vm-group>
        </vm-row>

        

        <vm-row>
            <vm-group c4>
                <vm-input v-model="$root.translations.shipping_early_1.nb_NO" maxbo disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-dropdown bold boldOptions maxbo v-if="!skEnabled"
                    v-model="orderModel.days3"
                    :options="orderOptions.days3"
                />
                <vm-input v-model="orderModel.days3.value" maxbo bold v-if="skEnabled" @input="onSKChange" />
            </vm-group>
            <vm-group c2>
                <vm-dropdown bold boldOptions maxbo v-if="!skEnabled"
                    v-model="discountModel.days3"
                    :options="discountOptions.days3"
                    :valid="checks.days3.discount"
                    :invalid="!checks.days3.discount"
                />
                <vm-input v-model="discountModel.days3.value" maxbo bold v-if="skEnabled" @input="onSKChange" />
            </vm-group>
            <vm-group c2>
                <vm-input v-model="prices.days3.original" maxbo bold disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-input v-model="prices.days3.discount" maxbo bold disabled borderless :highlight="prices.days3.highlight" />
            </vm-group>
        </vm-row>

        <div class="contact-hint">
            {{ __('max_value_hint_1') }}
        </div>

        <vm-label outside bold topMargin :text="__('shipping_normal')" />
        <vm-row>
            <vm-group c4>
                <vm-input v-model="$root.translations.shipping_normal_1.nb_NO" maxbo disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-dropdown bold boldOptions maxbo v-if="!skEnabled"
                    v-model="orderModel.low"
                    :options="orderOptions.low"
                    :invalid="!checks.low.threshold"
                    :error="!checks.thresholdOrder"
                />
                <vm-input v-model="orderModel.low.value" maxbo bold v-if="skEnabled" @input="onSKChange" />
            </vm-group>
            <vm-group c2>
                <vm-dropdown bold boldOptions maxbo v-if="!skEnabled"
                    v-model="discountModel.low"
                    :options="discountOptions.low"
                    :valid="checks.low.discount"
                    :invalid="!checks.low.discount"
                    :error="!checks.discountOrder"
                />
                <vm-input v-model="discountModel.low.value" maxbo bold v-if="skEnabled" @input="onSKChange" />
            </vm-group>
            <vm-group c2>
                <vm-input v-model="prices.low.original" maxbo bold disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-input v-model="prices.low.discount" maxbo bold disabled borderless :highlight="prices.low.highlight" />
            </vm-group>
        </vm-row>

        <vm-row v-if="!hideMed">
            <vm-group c4>
                <vm-input v-model="$root.translations.shipping_normal_2.nb_NO" maxbo disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-input v-model="orderModel.med.display" :invalid="!checks.med.threshold" :error="!checks.thresholdOrder" maxbo bold disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-dropdown bold boldOptions maxbo v-if="!skEnabled"
                    v-model="discountModel.med"
                    :options="discountOptions.med"
                    :valid="checks.med.discount"
                    :invalid="!checks.med.discount"
                    :error="!checks.discountOrder"
                />
                <vm-input v-model="discountModel.med.value" maxbo bold v-if="skEnabled" @input="onSKChange" />
            </vm-group>
            <vm-group c2>
                <vm-input v-model="prices.med.original" maxbo bold disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-input v-model="prices.med.discount" maxbo bold disabled borderless :highlight="prices.med.highlight" />
            </vm-group>
        </vm-row>

        <vm-row>
            <vm-group c4>
                <vm-input v-model="$root.translations.shipping_normal_3.nb_NO" maxbo disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-dropdown bold boldOptions maxbo v-if="!skEnabled"
                    v-model="orderModel.high"
                    :options="orderOptions.high"
                    :invalid="!checks.high.threshold"
                    :error="!checks.thresholdOrder"
                />
                <vm-input v-model="orderModel.high.value" maxbo bold v-if="skEnabled" @input="onSKChange" />
            </vm-group>
            <vm-group c2>
                <vm-dropdown bold boldOptions maxbo v-if="!skEnabled"
                    v-model="discountModel.high"
                    :options="discountOptions.high"
                    :valid="checks.high.discount"
                    :invalid="!checks.high.discount"
                    :error="!checks.discountOrder"
                />
                <vm-input v-model="discountModel.high.value" maxbo bold v-if="skEnabled" @input="onSKChange" />
            </vm-group>
            <vm-group c2>
                <vm-input v-model="prices.high.original" maxbo bold disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-input v-model="prices.high.discount" maxbo bold disabled borderless :highlight="prices.high.highlight" />
            </vm-group>
        </vm-row>

        <vm-row v-if="!checks.discountOrder">
            <vm-group c6 />
            <vm-group c6>
                <vm-label error :text="'*' + __('error_msg_1')" />
            </vm-group>
        </vm-row>
        <vm-row v-if="!checks.thresholdOrder">
            <vm-group c4 />
            <vm-group c8>
                <vm-label error :text="'*' + __('error_msg_2')" />
            </vm-group>
        </vm-row>
        <vm-row v-if="errorHigher1">
            <vm-group c8 />
            <vm-group c4>
                <vm-label error :text="'*' + __('error_msg_3')" />
            </vm-group>
        </vm-row>

        <div class="contact-hint">
            {{ __('max_value_hint_2') }}
        </div>

        <vm-label outside bold topMargin :text="__('shipping_special')" />
        <vm-row>
            <vm-group c4>
                <vm-input v-model="$root.translations.shipping_special_1.nb_NO" maxbo disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-dropdown bold boldOptions maxbo v-if="!skEnabled"
                    v-model="orderModel.precision"
                    :options="orderOptions.precision"
                />
                <vm-input v-model="orderModel.precision.value" maxbo bold v-if="skEnabled" @input="onSKChange" />
            </vm-group>
            <vm-group c2>
                <vm-dropdown bold boldOptions maxbo v-if="!skEnabled"
                    v-model="discountModel.precision"
                    :options="discountOptions.precision"
                    :valid="checks.precision.discount"
                    :invalid="!checks.precision.discount"
                />
                <vm-input v-model="discountModel.precision.value" maxbo bold v-if="skEnabled" @input="onSKChange" />
            </vm-group>
            <vm-group c2>
                <vm-input v-model="prices.precision.original" maxbo bold disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-input v-model="prices.precision.discount" maxbo bold disabled borderless :highlight="prices.precision.highlight" />
            </vm-group>
        </vm-row>

        <vm-row>
            <vm-group c4>
                <vm-input v-model="$root.translations.shipping_special_2.nb_NO" maxbo disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-dropdown bold boldOptions maxbo v-if="!skEnabled"
                    v-model="orderModel.express"
                    :options="orderOptions.express"
                />
                <vm-input v-model="orderModel.express.value" maxbo bold v-if="skEnabled" @input="onSKChange" />
            </vm-group>
            <vm-group c2>
                <vm-dropdown bold boldOptions maxbo v-if="!skEnabled"
                    v-model="discountModel.express"
                    :options="discountOptions.express"
                    :valid="checks.express.discount"
                    :invalid="!checks.express.discount"
                />
                <vm-input v-model="discountModel.express.value" maxbo bold v-if="skEnabled" @input="onSKChange" />
            </vm-group>
            <vm-group c2>
                <vm-input v-model="prices.express.original" maxbo bold disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-input v-model="prices.express.discount" maxbo bold disabled borderless :highlight="prices.express.highlight" />
            </vm-group>
        </vm-row>

        <vm-row>
            <vm-group c4>
                <vm-input v-model="$root.translations.shipping_special_3.nb_NO" maxbo disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-dropdown bold boldOptions maxbo v-if="!skEnabled"
                    v-model="orderModel.crane"
                    :options="orderOptions.crane"
                />
                <vm-input v-model="orderModel.crane.value" maxbo bold v-if="skEnabled" @input="onSKChange" />
            </vm-group>
            <vm-group c2>
                <vm-dropdown bold boldOptions maxbo v-if="!skEnabled"
                    v-model="discountModel.crane"
                    :options="discountOptions.crane"
                    :valid="checks.crane.discount"
                    :invalid="!checks.crane.discount"
                />
                <vm-input v-model="discountModel.crane.value" maxbo bold v-if="skEnabled" @input="onSKChange" />
            </vm-group>
            <vm-group c2>
                <vm-input v-model="prices.crane.original" maxbo bold disabled borderless />
            </vm-group>
            <vm-group c2>
                <vm-input v-model="prices.crane.discount" maxbo bold disabled borderless :highlight="prices.crane.highlight" />
            </vm-group>
        </vm-row>

        <vm-row v-if="errorHigher2">
            <vm-group c8 />
            <vm-group c4>
                <vm-label error :text="'*' + __('error_msg_4')" />
            </vm-group>
        </vm-row>

        <div class="contact-hint">
            {{ __('max_value_hint_3') }}
        </div>

    </vm-card>
</div>
</template>
<script>
import nformat from '../nformat';

export default {
name: 'ShippingTable',
props: {
    value: {
        type: Object,
        default: null
    },
    skEnabled: {
        type: Boolean,
        default: false
    },
    thresholdValues: {
        type: Array,
        default: null
    }
},
data() {
    return {
        hideMed: false,
        orderOptions: {
            days7: [],
            days3: [],
            low: [],
            med: [],
            high: [],
            precision: [],
            express: [],
            crane: []
        },
        discountOptions: {
            days7: [],
            days3: [],
            low: [],
            med: [],
            high: [],
            precision: [],
            express: [],
            crane: []
        },
        orderModel: {
            days7: {
                value: '0',
                display: '0 kr'
            },
            days3: {
                value: '0',
                display: '0 kr'
            },
            low: {
                value: '0',
                display: '0 kr'
            },
            med: {
                value: '0',
                display: '0 kr'
            },
            high: {
                value: '0',
                display: '0 kr'
            },
            precision: {
                value: '0',
                display: '0 kr'
            },
            express: {
                value: '0',
                display: '0 kr'
            },
            crane: {
                value: '0',
                display: '0 kr'
            }
        },
        discountModel: {
            days7: {
                value: '0',
                display: '0 %'
            },
            days3: {
                value: '0',
                display: '0 %'
            },
            low: {
                value: '0',
                display: '0 %'
            },
            med: {
                value: '0',
                display: '0 %'
            },
            high: {
                value: '0',
                display: '0 %'
            },
            precision: {
                value: '0',
                display: '0 %'
            },
            express: {
                value: '0',
                display: '0 %'
            },
            crane: {
                value: '0',
                display: '0 %'
            }
        },
        prices: {
            days7: {
                original: '0',
                discount: '0',
                highlight: false
            },
            days3: {
                original: '0',
                discount: '0',
                highlight: false
            },
            low: {
                original: '0',
                discount: '0',
                highlight: false
            },
            med: {
                original: '0',
                discount: '0',
                highlight: false
            },
            high: {
                original: '0',
                discount: '0',
                highlight: false
            },
            precision: {
                original: '0',
                discount: '0',
                highlight: false
            },
            express: {
                original: '0',
                discount: '0',
                highlight: false
            },
            crane: {
                original: '0',
                discount: '0',
                highlight: false
            }
        },
        checks: {
            thresholdOrder: true,
            discountOrder: true,
            days7: {
                discount: true
            },
            days3: {
                discount: true
            },
            low: {
                discount: true,
                threshold: true
            },
            med: {
                discount: true,
                threshold: true
            },
            high: {
                discount: true,
                threshold: true
            },
            precision: {
                discount: true
            },
            express: {
                discount: true
            },
            crane: {
                discount: true
            }
        },
        errorHigher1: false,
        errorHigher2: false,
    }
},
watch: {
    /* eslint-disable no-unused-vars */
    discountModel: {
        deep: true,
        handler(val) {
            this.onChange();
        }
    },
    orderModel: {
        deep: true,
        handler(val) {
            this.onChange();
        }
    }
},
methods: {

    onChange() {

        if (this.orderModel.low.value == this.orderModel.high.value) {
            this.hideMed = true;
        }else {
            this.hideMed = false;
        }
        if (this.hideMed) {
            this.discountModel.med.value = this.discountModel.high.value;
        }
        this.orderModel.med.display = this.orderModel.low.display + ' - ' + this.orderModel.high.display;

        this.updateModel();
        this.calculatePrices();
        this.validate();
    },

    onSKChange() {
        this.updateModelDisplay(this.orderModel.days7, this.discountModel.days7);
        this.updateModelDisplay(this.orderModel.days3, this.discountModel.days3);
        this.updateModelDisplay(this.orderModel.low, this.discountModel.low);
        this.updateModelDisplay(this.orderModel.med, this.discountModel.med);
        this.updateModelDisplay(this.orderModel.high, this.discountModel.high);
        this.updateModelDisplay(this.orderModel.precision, this.discountModel.precision);
        this.updateModelDisplay(this.orderModel.express, this.discountModel.express);
        this.updateModelDisplay(this.orderModel.crane, this.discountModel.crane);
        this.onChange();
    },

    updateModel() {
        this.updateSingleModel(this.value.days7, this.orderModel.days7, this.discountModel.days7);
        this.updateSingleModel(this.value.days3, this.orderModel.days3, this.discountModel.days3);
        this.updateSingleModel(this.value.low, this.orderModel.low, this.discountModel.low);
        this.updateSingleModel(this.value.med, this.orderModel.med, this.discountModel.med);
        this.updateSingleModel(this.value.high, this.orderModel.high, this.discountModel.high);
        this.updateSingleModel(this.value.precision, this.orderModel.precision, this.discountModel.precision);
        this.updateSingleModel(this.value.express, this.orderModel.express, this.discountModel.express);
        this.updateSingleModel(this.value.crane, this.orderModel.crane, this.discountModel.crane);
    },

    updateSingleModel(value, orderModel, discountModel) {
        value.threshold = orderModel.value;
        value.discount = discountModel.value;
    },

    updateModelDisplay(orderModel, discountModel) {
        orderModel.display = nformat.formatMoney(Number(orderModel.value));
        discountModel.display = discountModel.value + ' %';
    },

    validate() {
        const result = {
            approval: false,
            error: false
        }

        this.checks.days7.discount = this.validateDiscount(this.value.days7);
        this.checks.days3.discount = this.validateDiscount(this.value.days3);
        this.checks.low.discount = this.validateDiscount(this.value.low);
        this.checks.med.discount = this.validateDiscount(this.value.med);
        this.checks.high.discount = this.validateDiscount(this.value.high);
        this.checks.precision.discount = this.validateDiscount(this.value.precision);
        this.checks.express.discount = this.validateDiscount(this.value.express);
        this.checks.crane.discount = this.validateDiscount(this.value.crane);

        if (!this.checks.days7.discount) result.approval = true;
        if (!this.checks.days3.discount) result.approval = true;
        if (!this.checks.low.discount) result.approval = true;
        if (!this.checks.med.discount) result.approval = true;
        if (!this.checks.high.discount) result.approval = true;
        if (!this.checks.precision.discount) result.approval = true;
        if (!this.checks.express.discount) result.approval = true;
        if (!this.checks.crane.discount) result.approval = true;


        this.checks.thresholdOrder = !(Number(this.value.low.threshold) > Number(this.value.high.threshold));
        if (!this.checks.thresholdOrder) result.error = true;

    
        if (Number(this.value.med.discount) < Number(this.value.low.discount)
        || Number(this.value.high.discount) < Number(this.value.low.discount)
        || Number(this.value.high.discount) < Number(this.value.med.discount)) {
            this.checks.discountOrder = false;
            result.error = true;
        }else {
            this.checks.discountOrder = true;
        }


        this.$emit('validated', result);
    },

    calculatePrices() {
        this.calculatePrice(this.prices.days7, this.value.days7);
        this.calculatePrice(this.prices.days3, this.value.days3);
        this.calculatePrice(this.prices.low, this.value.low);
        this.calculatePrice(this.prices.med, this.value.med);
        this.calculatePrice(this.prices.high, this.value.high);
        this.calculatePrice(this.prices.precision, this.value.precision);
        this.calculatePrice(this.prices.express, this.value.express);
        this.calculatePrice(this.prices.crane, this.value.crane);
        try {

            let highest1 = this.getNumber(this.prices.days7.discount);
            if (this.getNumber(this.prices.days3.discount) > highest1) highest1 = this.getNumber(this.prices.days3.discount);

            //console.log('highest1', highest1);

            let lowest2 = this.getNumber(this.prices.low.discount);
            if (this.getNumber(this.prices.med.discount) < lowest2) lowest2 = this.getNumber(this.prices.med.discount);
            if (this.getNumber(this.prices.high.discount) < lowest2) lowest2 = this.getNumber(this.prices.high.discount);

            //console.log('lowest2', lowest2);

            if (lowest2 < highest1) {
                this.errorHigher1 = true;
            }else {
                this.errorHigher1 = false;
            }


            let highest2 = this.getNumber(this.prices.low.discount);
            if (this.getNumber(this.prices.med.discount) > highest2) highest2 = this.getNumber(this.prices.med.discount);
            if (this.getNumber(this.prices.high.discount) > highest2) highest2 = this.getNumber(this.prices.high.discount);

            //console.log('highest2', highest2);

            let lowest3 = this.getNumber(this.prices.precision.discount);
            if (this.getNumber(this.prices.express.discount) < lowest3) lowest3 = this.getNumber(this.prices.express.discount);

            //console.log('lowest3', lowest3);

            if (lowest3 < highest2) {
                this.errorHigher2 = true;
            }else {
                this.errorHigher2 = false;
            }

        }catch (ex) {
            console.log('error comparing prices');
        }
    },

    getNumber(value) {
        return Number(value.replace(' kr', '').replace(' ', '').replace(' ', ''));
    },

    calculatePrice(price, model) {
        price.original = nformat.formatMoney(Number(model.price));
        price.discount = nformat.formatMoney(Math.round(Number(model.price) - ((Number(model.price) * Number(model.discount)) / 100)));
        price.highlight = Number(model.discount) > 0;
    },

    validateDiscount(item) {
        return (Number(item.discount) < Number(item.maxDiscount));
    },

    getOrderOptions() {
        return JSON.parse(JSON.stringify(this.thresholdValues));
    },

    getDiscountOptions(max, ddMax) {
        const list = [];
        for (let i = 0; i < 11; i++) {
            if ((i * 10) <= ddMax) {
                list.push({
                    key: 'd' + i,
                    value: (i * 10),
                    display: (i * 10) + " %",
                    warning: (i * 10) >= max
                });
            }
        }
        return list;
    },

    loadOrderModel() {
        this.orderModel.days7.value = this.value.days7.threshold;
        this.orderModel.days7.display = nformat.formatMoney(Number(this.value.days7.threshold));
        this.orderModel.days3.value = this.value.days3.threshold;
        this.orderModel.days3.display = nformat.formatMoney(Number(this.value.days3.threshold));
        this.orderModel.low.value = this.value.low.threshold;
        this.orderModel.low.display = nformat.formatMoney(Number(this.value.low.threshold));
        this.orderModel.med.value = this.value.med.threshold;
        this.orderModel.med.display = nformat.formatMoney(Number(this.value.med.threshold));
        this.orderModel.high.value = this.value.high.threshold;
        this.orderModel.high.display = nformat.formatMoney(Number(this.value.high.threshold));
        this.orderModel.precision.value = this.value.precision.threshold;
        this.orderModel.precision.display = nformat.formatMoney(Number(this.value.precision.threshold));
        this.orderModel.express.value = this.value.express.threshold;
        this.orderModel.express.display = nformat.formatMoney(Number(this.value.express.threshold));
        this.orderModel.crane.value = this.value.crane.threshold;
        this.orderModel.crane.display = nformat.formatMoney(Number(this.value.crane.threshold));
    },

    loadDiscountModel() {
        this.discountModel.days7.value = this.value.days7.discount;
        this.discountModel.days7.display = this.value.days7.discount + ' %';
        this.discountModel.days3.value = this.value.days3.discount;
        this.discountModel.days3.display = this.value.days3.discount + ' %';
        this.discountModel.low.value = this.value.low.discount;
        this.discountModel.low.display = this.value.low.discount + ' %';
        this.discountModel.med.value = this.value.med.discount;
        this.discountModel.med.display = this.value.med.discount + ' %';
        this.discountModel.high.value = this.value.high.discount;
        this.discountModel.high.display = this.value.high.discount + ' %';
        this.discountModel.precision.value = this.value.precision.discount;
        this.discountModel.precision.display = this.value.precision.discount + ' %';
        this.discountModel.express.value = this.value.express.discount;
        this.discountModel.express.display = this.value.express.discount + ' %';
        this.discountModel.crane.value = this.value.crane.discount;
        this.discountModel.crane.display = this.value.crane.discount + ' %';
    }

},
mounted() {
    this.loadOrderModel();
    this.loadDiscountModel();

    this.orderOptions.days7 = this.getOrderOptions();
    this.orderOptions.days3 = this.getOrderOptions();
    this.orderOptions.low = this.getOrderOptions();
    this.orderOptions.med = this.getOrderOptions();
    this.orderOptions.high = this.getOrderOptions();
    this.orderOptions.precision = this.getOrderOptions();
    this.orderOptions.express = this.getOrderOptions();
    this.orderOptions.crane = this.getOrderOptions();

    this.discountOptions.days7 = this.getDiscountOptions(this.value.days7.maxDiscount, this.value.days7.ddDiscount);
    this.discountOptions.days3 = this.getDiscountOptions(this.value.days3.maxDiscount, this.value.days3.ddDiscount);
    this.discountOptions.low = this.getDiscountOptions(this.value.low.maxDiscount, this.value.low.ddDiscount);
    this.discountOptions.med = this.getDiscountOptions(this.value.med.maxDiscount, this.value.med.ddDiscount);
    this.discountOptions.high = this.getDiscountOptions(this.value.high.maxDiscount, this.value.high.ddDiscount);
    this.discountOptions.precision = this.getDiscountOptions(this.value.precision.maxDiscount, this.value.precision.ddDiscount);
    this.discountOptions.express = this.getDiscountOptions(this.value.express.maxDiscount, this.value.express.ddDiscount);
    this.discountOptions.crane = this.getDiscountOptions(this.value.crane.maxDiscount, this.value.crane.ddDiscount);

    this.calculatePrices();
}
}
</script>
<style scoped>

.contact-hint {
    float: left;
    width: 100%;
    padding-left: 20px;
    margin-top: 2px;
    margin-bottom: 8px;
    font-size: 15px;
    font-style: italic;
    color: gray;
}

</style>
